import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
  apiKey: "AIzaSyB1ZDw8g7FDaSXB3hUijzWJpmIf4eIgzrQ",
  authDomain: "slardar-portal.firebaseapp.com",
  projectId: "slardar-portal",
  storageBucket: "slardar-portal.firebasestorage.app",
  messagingSenderId: "338688890607",
  appId: "1:338688890607:web:01de7c921fa7c216e06d1a"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // Add this expor